import React, { Component } from "react";
import cookie from "react-cookie";
import { browserHistory } from "react-router";
import {
    FormGroup,
    FormControl,
    Button,
    Alert,
    Checkbox
} from "react-bootstrap";
import "./LoginForm.css";
import axios from "axios";
import jwtDecode from 'jwt-decode';

import mixpanel from 'mixpanel-browser';

class LoginForm extends Component {

    constructor(props) {
        super(props);

        this.state = {
            user: {
                email: "",
                password: "",
                rememberMe: true,                
            },
            error: "",
            initialMessage: this.props.initialMessage,
            submitting: false
        };

        this.processForm = this.processForm.bind(this);
        this.changeUser = this.changeUser.bind(this);
        
        this.mixpanel = mixpanel;
    }

    processForm(event) {

    	this.setState({submitting: true});

        event.preventDefault();

        const requestData = {
            username: this.state.user.email,
            password: this.state.user.password,
            rememberMe: this.state.user.rememberMe
        };

        let that = this;

        axios
            .post("/api/authenticate", requestData)
            .then(function(response) {
            	that.setState({submitting: false});
                if (!response.data || !response.data.id_token) {
                    that.setState({ error: "Sorry, please contact support" });
                } else {
                    const jwt = response.data.id_token;
                    const jwtDecoded = jwtDecode(jwt);
                    const jwtExpiry = new Date(jwtDecoded.exp * 1000);
                    cookie.save("webfinery.jwt", jwt, { path: "/", expires: jwtExpiry });
                    axios.defaults.headers.common["Authorization"] = "Bearer " +
                        jwt;

                    that.mixpanel.identify(that.state.user.email);                    
                    browserHistory.push("/login/success");
                }
            })
            .catch(function(error) {
            	that.setState({submitting: false});
                that.setState({ initialMessage: "" });                
                if (error.response && error.response.status === 401) {
                    that.setState({ error: "Incorrect login and/or password" });
                } else {
                    that.setState({
                        error: "Sorry, there was an error, try again later"
                    });
                    console.dir(error.response);
                }
            });
    }

    changeUser(event) {
        const field = event.target.name;
        const user = this.state.user;
        let newValue = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        user[field] = newValue;

        this.setState({
            user: user,
            error: ""
        });
    }

    render() {
        const errors = this.state.error
            ? <Alert bsStyle="danger">{this.state.error}</Alert>
            : <Alert />;

        const initialMessage = this.state.initialMessage
            ? <Alert bsStyle="info">{this.state.initialMessage}</Alert>
            : null;

        const submitLabel = this.state.submitting ? "Logging in..." : "Log in";

        return (
            <form className="login-form" action="/" onSubmit={this.processForm}>

                <h1>Log in</h1>
                <FormGroup>
                    {initialMessage}
                    {errors}
                </FormGroup>
                <FormGroup>
                    <FormControl
                        type="text"
                        placeholder="Email"
                        value={this.state.user.email}
                        onChange={this.changeUser}
                        name="email"
                    />
                </FormGroup>
                <FormGroup>
                    <FormControl
                        type="password"
                        placeholder="Password"
                        value={this.state.user.password}
                        onChange={this.changeUser}
                        name="password"
                    />
                </FormGroup>
                <FormGroup>
                    <Checkbox
                        inline
                        checked={this.state.user.rememberMe}
                        onChange={this.changeUser}
                        name="rememberMe"
                    >
                        Remember me
                    </Checkbox>
                </FormGroup>
                <FormGroup>
                    <Button
                        disabled={this.state.submitting}
                        type="submit"
                        bsStyle="success"
                    >
                        {submitLabel}
                    </Button>
                </FormGroup>

            </form>
        );
    }
}

export default LoginForm;



// WEBPACK FOOTER //
// ./src/auth/LoginForm.js